/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconChevronsDownLeft = createReactComponent("outline", "chevrons-down-left", "IconChevronsDownLeft", [["path", { "d": "M11 5v8h8", "key": "svg-0" }], ["path", { "d": "M7 9v8h8", "key": "svg-1" }]]);

export { IconChevronsDownLeft as default };
//# sourceMappingURL=IconChevronsDownLeft.mjs.map
